import { regions, shop_domain_prefix } from "@/util/constants";

/**
 * Returns the shop domain based on the specified region. At this time, only returns the English or German shop domain for the European region or the US one for all other regions.
 *
 * @param region - The region for which to get the shop domain. Can be either 'EUROPE' or anything other value.
 * @param locale - The locale of the shop. Either 'de' or 'en'.
 * @returns The shop domain URL as a whole.
 */
export default function getShopDomain(region: string, locale: string) {
  return region === regions.EUROPE
    ? `${shop_domain_prefix}.${locale === "de" ? "de" : "com"}`
    : `${shop_domain_prefix}.us`;
}
